export default __webpack_public_path__ + "static/media/TRR-drink-juice.ca84c4fa.png";